import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { MicrosoftSignIn, MicrosoftSignInFieldSchema } from './components';

export const MicrosoftSignInFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'MicrosoftSignIn',
    component: MicrosoftSignIn,
    schema: MicrosoftSignInFieldSchema.schema,
  }),
);
